import { PRIVACY_PATH, TERMS_PATH } from '@orbit-mind/shared-types';
import { useLocale } from '@orbit-mind/engine-react';
import { Button, SwitchRow } from '../ui/controls';

export function ConsentStep({ news, onNewsChange, onBack, onAccept, continueHref }: {
  readonly news: boolean;
  readonly onNewsChange: (value: boolean) => void;
  readonly onBack: () => void;
  readonly onAccept: () => void;
  readonly continueHref?: string;
}): React.JSX.Element {
  const { text: t } = useLocale();
  const label = t('Accept and continue', 'Aceitar e continuar');
  return <div className="grid gap-5" data-consent-step>
    <h3 className="text-lg font-semibold">{t('Before you continue', 'Antes de continuar')}</h3>
    <p className="text-ink-muted text-sm leading-relaxed">
      {t('To use your Orbit Mind account, please read and accept our ', 'Para usar sua conta Orbit Mind, leia e aceite nossos ')}
      <a href={TERMS_PATH} target="_blank" rel="noreferrer" className="text-accent underline">{t('Terms of Use', 'Termos de Uso')}</a>
      {t(' and ', ' e ')}
      <a href={PRIVACY_PATH} target="_blank" rel="noreferrer" className="text-accent underline">{t('Privacy Policy', 'Política de Privacidade')}</a>.
    </p>
    <SwitchRow id="product-news" checked={news} onChange={onNewsChange}>
      {t('Receive product news by email (optional)', 'Receber novidades por e-mail (opcional)')}
    </SwitchRow>
    <p className="text-ink-faint text-xs">{t('By choosing “Accept and continue”, you accept these documents. You can use your maps without an account.', 'Ao escolher “Aceitar e continuar”, você aceita esses documentos. Você pode usar seus mapas sem uma conta.')}</p>
    {continueHref ? <a href={continueHref} onClick={onAccept} className="bg-prisma text-accent-ink flex min-h-12 items-center justify-center rounded-xl px-4 font-semibold">{label}</a> :
      <Button tone="primary" size="lg" onClick={onAccept}>{label}</Button>}
    <Button onClick={onBack}>{t('Back', 'Voltar')}</Button>
  </div>;
}
